import { render, staticRenderFns } from "./EditableField.vue?vue&type=template&id=35fd7464&scoped=true"
import script from "./EditableField.vue?vue&type=script&lang=js"
export * from "./EditableField.vue?vue&type=script&lang=js"
import style0 from "./EditableField.vue?vue&type=style&index=0&id=35fd7464&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fd7464",
  null
  
)

export default component.exports